// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Column$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as OrderDashboardDataMachine from "../../../app/order/OrderDashboardDataMachine.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as PricingDashboardAssetsManager from "../../../../pricing-dashboard/view/assets/PricingDashboardAssetsManager.bs.js";

var validators_comment = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var comment = param.comment;
      if (comment !== undefined && comment.length !== 0) {
        return {
                TAG: /* Ok */0,
                _0: comment
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: ""
              };
      }
    })
};

var validators_msisdn = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var msisdn = param.msisdn;
      if (msisdn !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: msisdn
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: ""
              };
      }
    })
};

var validators = {
  comment: validators_comment,
  reason: undefined,
  msisdn: validators_msisdn,
  crn: undefined
};

function initialFieldsStatuses(_input) {
  return {
          comment: /* Pristine */0,
          reason: /* Pristine */0,
          msisdn: /* Pristine */0,
          crn: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            comment: /* Pristine */0,
            reason: /* Pristine */0,
            msisdn: /* Pristine */0,
            crn: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.comment;
  var match_0 = match ? match._0 : Curry._1(validators.comment.validate, input);
  var match_0$1 = {
    TAG: /* Ok */0,
    _0: input.reason
  };
  var match$1 = fieldsStatuses.msisdn;
  var match_0$2 = match$1 ? match$1._0 : Curry._1(validators.msisdn.validate, input);
  var match_0$3 = {
    TAG: /* Ok */0,
    _0: input.crn
  };
  var commentResult = match_0;
  var commentResult$1;
  if (commentResult.TAG === /* Ok */0) {
    var reasonResult = match_0$1;
    if (reasonResult.TAG === /* Ok */0) {
      var msisdnResult = match_0$2;
      if (msisdnResult.TAG === /* Ok */0) {
        var crnResult = match_0$3;
        if (crnResult.TAG === /* Ok */0) {
          return {
                  TAG: /* Valid */0,
                  output: {
                    crn: crnResult._0,
                    msisdn: msisdnResult._0,
                    reason: reasonResult._0,
                    comment: commentResult._0
                  },
                  fieldsStatuses: {
                    comment: /* Dirty */{
                      _0: commentResult,
                      _1: /* Shown */0
                    },
                    reason: /* Dirty */{
                      _0: reasonResult,
                      _1: /* Hidden */1
                    },
                    msisdn: /* Dirty */{
                      _0: msisdnResult,
                      _1: /* Shown */0
                    },
                    crn: /* Dirty */{
                      _0: crnResult,
                      _1: /* Hidden */1
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        commentResult$1 = commentResult;
      } else {
        commentResult$1 = commentResult;
      }
    } else {
      commentResult$1 = commentResult;
    }
  } else {
    commentResult$1 = commentResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            comment: /* Dirty */{
              _0: commentResult$1,
              _1: /* Shown */0
            },
            reason: /* Dirty */{
              _0: match_0$1,
              _1: /* Hidden */1
            },
            msisdn: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            crn: /* Dirty */{
              _0: match_0$3,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurCommentField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.comment, validators_comment, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  comment: status,
                                  reason: init.reason,
                                  msisdn: init.msisdn,
                                  crn: init.crn
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurReasonField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.reason, state.fieldsStatuses.reason, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  comment: init.comment,
                                  reason: status,
                                  msisdn: init.msisdn,
                                  crn: init.crn
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMsisdnField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.msisdn, validators_msisdn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  comment: init.comment,
                                  reason: init.reason,
                                  msisdn: status,
                                  crn: init.crn
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCrnField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithoutValidator(state.input.crn, state.fieldsStatuses.crn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  comment: init.comment,
                                  reason: init.reason,
                                  msisdn: init.msisdn,
                                  crn: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */4 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */4,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */5,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */7);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */6);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */5 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */6 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */7 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateCommentField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.comment, state.submissionStatus, validators_comment, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            comment: status,
                                            reason: init.reason,
                                            msisdn: init.msisdn,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateReasonField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.reason, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            comment: init.comment,
                                            reason: status,
                                            msisdn: init.msisdn,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMsisdnField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.msisdn, state.submissionStatus, validators_msisdn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            comment: init.comment,
                                            reason: init.reason,
                                            msisdn: status,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCrnField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$3.crn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            comment: init.comment,
                                            reason: init.reason,
                                            msisdn: init.msisdn,
                                            crn: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */4 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                comment: /* Pristine */0,
                                reason: /* Pristine */0,
                                msisdn: /* Pristine */0,
                                crn: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                comment: /* Pristine */0,
                                reason: /* Pristine */0,
                                msisdn: /* Pristine */0,
                                crn: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */5 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */6 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateComment: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCommentField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateReason: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateReasonField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMsisdn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMsisdnField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCrn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCrnField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurComment: (function (param) {
              return Curry._1(dispatch, /* BlurCommentField */0);
            }),
          blurReason: (function (param) {
              return Curry._1(dispatch, /* BlurReasonField */1);
            }),
          blurMsisdn: (function (param) {
              return Curry._1(dispatch, /* BlurMsisdnField */2);
            }),
          blurCrn: (function (param) {
              return Curry._1(dispatch, /* BlurCrnField */3);
            }),
          commentResult: Formality.exposeFieldResult(state.fieldsStatuses.comment),
          reasonResult: Formality.exposeFieldResult(state.fieldsStatuses.reason),
          msisdnResult: Formality.exposeFieldResult(state.fieldsStatuses.msisdn),
          crnResult: Formality.exposeFieldResult(state.fieldsStatuses.crn),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.comment || match.reason || match.msisdn || match.crn) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */4);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */5);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */6);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */6,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */7);
            })
        };
}

var PartnerGoodwillForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var reason = "Cancelled by customer";

var PartnerGoodwillConfig = {
  reason: reason
};

function PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm$LabelledTextInputWrapper(Props) {
  var label = Props.label;
  var class_nameOpt = Props.class_name;
  var children = Props.children;
  var class_name = class_nameOpt !== undefined ? class_nameOpt : "";
  return React.createElement(Column$Catalyst.make, {
              children: null,
              className: "c-input-text-wrapper " + class_name
            }, React.createElement("label", {
                  className: "input-text-label"
                }, label + ":"), children);
}

var LabelledTextInputWrapper = {
  make: PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm$LabelledTextInputWrapper
};

function PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm(Props) {
  var crn = Props.crn;
  var msisdn = Props.msisdn;
  var reasonOpt = Props.reason;
  var on_submit_cb = Props.on_submit_cb;
  var reason$1 = reasonOpt !== undefined ? reasonOpt : reason;
  var form = useForm({
        crn: crn,
        msisdn: msisdn,
        reason: reason$1,
        comment: undefined
      }, (function (output, submissionCbs) {
          Curry._2(on_submit_cb, output.crn, output.comment);
          return Curry._1(submissionCbs.notifyOnSuccess, undefined);
        }));
  return React.createElement("form", {
              className: "c-partner-goodwill-form",
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  
                })
            }, React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "order-partner-row"
                }, React.createElement(PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm$LabelledTextInputWrapper, {
                      label: "CRN",
                      class_name: "order-input",
                      children: React.createElement(FormTextInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                    return Curry._2(form.updateCrn, (function (input, value) {
                                                  return {
                                                          crn: value,
                                                          msisdn: input.msisdn,
                                                          reason: input.reason,
                                                          comment: input.comment
                                                        };
                                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                  }), true, undefined, "CRN", undefined, undefined, undefined, form.crnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            textinput_props: {
                              value: form.input.crn
                            }
                          })
                    }), React.createElement(PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm$LabelledTextInputWrapper, {
                      label: "Partner MSISDN",
                      class_name: "msisdn-input",
                      children: React.createElement(FormTextInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                    return Curry._2(form.updateMsisdn, (function (input, value) {
                                                  return {
                                                          crn: input.crn,
                                                          msisdn: value,
                                                          reason: input.reason,
                                                          comment: input.comment
                                                        };
                                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                  }), true, undefined, "MSISDN", undefined, undefined, undefined, form.msisdnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            textinput_props: {
                              value: Belt_Option.getWithDefault(form.input.msisdn, "")
                            }
                          })
                    })), React.createElement(PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm$LabelledTextInputWrapper, {
                  label: "Reason",
                  children: React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(form.updateReason, (function (input, value) {
                                              return {
                                                      crn: input.crn,
                                                      msisdn: input.msisdn,
                                                      reason: value,
                                                      comment: input.comment
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), true, undefined, "Reason", undefined, undefined, undefined, form.reasonResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: form.input.reason
                        }
                      })
                }), React.createElement(PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm$LabelledTextInputWrapper, {
                  label: "Comment",
                  children: React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(form.updateComment, (function (input, value) {
                                              return {
                                                      crn: input.crn,
                                                      msisdn: input.msisdn,
                                                      reason: input.reason,
                                                      comment: value
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), undefined, undefined, "Comment", undefined, undefined, undefined, form.commentResult, undefined, "comment-text-input", true, undefined, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: Belt_Option.getWithDefault(form.input.comment, "")
                        }
                      })
                }), React.createElement(PrimaryButton$Catalyst.make, {
                  buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                        TAG: /* Text */0,
                        _0: "Give Goodwil Bonus"
                      }, !Curry._1(form.valid, undefined), (function (param) {
                          return Curry._1(form.submit, undefined);
                        }), undefined, undefined, undefined, undefined, "c-mui-primary-btn " + (
                        Curry._1(form.valid, undefined) ? "" : "e-disabled-btn"
                      ), undefined, undefined)
                }));
}

var PartnerGoodwillDiscountForm = {
  PartnerGoodwillForm: PartnerGoodwillForm,
  PartnerGoodwillConfig: PartnerGoodwillConfig,
  LabelledTextInputWrapper: LabelledTextInputWrapper,
  make: PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm
};

function PartnerGoodwillDiscountCmp(Props) {
  var crn = Props.crn;
  var msisdn = Props.msisdn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(undefined, undefined, undefined);
  var openSnackbar = match$1[1];
  var createPartnerGoodwillDiscount = function (crn, comment) {
    return OrderDashboardDataMachine.createPartnerGoodwillDiscount({
                order_id: crn,
                comment: comment
              }, (function (data) {
                  return Curry._1(openSnackbar, {
                              TAG: /* Success */0,
                              _0: "Goodwill bonus of ₹" + (data.amount.toString() + " has been credited to partner")
                            });
                }), (function (error) {
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            });
                }), country);
  };
  var info_icon = PricingDashboardAssetsManager.getImage("info-icon.svg");
  var PartnerGoodwillDiscountCmp$1 = function (Props) {
    var text = Props.text;
    return React.createElement(Row$Catalyst.make, {
                children: null,
                className: "c-form-warning-text"
              }, React.createElement("img", {
                    className: "warning-icon",
                    src: info_icon
                  }), text);
  };
  return React.createElement("div", {
              className: "c-partner-goodwill"
            }, React.createElement("div", {
                  className: "title"
                }, "Give Goodwill Bonus"), Belt_Option.isNone(msisdn) ? React.createElement(PartnerGoodwillDiscountCmp$1, {
                    text: "Partner has not been allocated yet."
                  }) : null, React.createElement(PartnerGoodwillDiscountCmp$PartnerGoodwillDiscountForm, {
                  crn: crn,
                  msisdn: msisdn,
                  on_submit_cb: createPartnerGoodwillDiscount
                }), match$1[0]);
}

var make = PartnerGoodwillDiscountCmp;

export {
  PartnerGoodwillDiscountForm ,
  make ,
  
}
/* react Not a pure module */
